import { data } from "jquery"

const completionStatuses = {
  // The request has not yet been executed successfully, and no (valid) void request has been issued for it.
  // Records in this state are eligible for replay, pending other factors. (All new records are created in the pending state.)
  1: "Pending",

  // The request has been executed successfully, and no (valid) void request has been issued for it.
  // Records in this stage are not eligible for replay.
  2: "Complete",

  // A void request has been issued for this request, but it has not yet been completed (successfully or otherwise).
  // There will be another store-and-forward record representing the void operation
  3: "Voiding",

  // The request has been voided successfully. It cannot transition to another state.
  4: "Voided",
}

const responseStatuses = {
  1: "No response data exists",
  2: "Card reader still offline",
  3: "Transaction declined during replay",
  4: "Transaction approved",
  5: "Voided without communicating with the server",
}

export const statusCheckComplete = (data) => {
  if (data.reasonText || data.message) {
    if ((data.reasonText && data.reasonText !== 'APPROVED OFFLINE') && (data.message && data.message !== 'APPROVED OFFLINE')) {
      return true
    }
  }

  return [ 3, 4 ].includes(data.responseStatus)
}

export const responseStatusString = (responseStatus) => responseStatuses[responseStatus]

export const approvedOfflineThenDeclined = (data) => {
  if (data.reasonText || data.message) {
    if (data.reasonText === 'DECLINE' || data.message === 'DECLINE') {
      return true
    }

    if (data.reasonText === 'APPROVED OFFLINE' || data.message === 'APPROVED OFFLINE') {
      const receiptData = data.receiptData

      if (receiptData?.approvalCode === 'D') {
        return true
      }
    }
  }

  return data.responseStatus === 3
}

export const isOfflineApproval = (cardReaderData) => {
  const data = cardReaderData || {}
  const requestId = data.requestId || ""

  return cardReaderData.isOfflineApproval || requestId.substring(0,3) === "00Y"
}
